module.exports = __webpack_public_path__ + "img/AuxiliaryAdvisor-dark.3956017a.svg";